import { useState, useEffect } from "react";
import DataViewPage from "../../controls/DataViewPage";
import { toast } from "react-toastify";
import { getTables, handleDeleteTable } from "../../../api/KOTApi";
import { useSelector } from "react-redux";
import CustomTable from "../../controls/CustomTable";
import AddTable from "./AddTable";
import ConfirmBox from "../../controls/ConfirmBox";

const Table = () => {
  const [activeTab, setActiveTab] = useState("active");
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddTable, setAddTable] = useState(false);
  const [selectedTable, setSelectedTable] = useState({});
  const [showConfirmation, setShowConfirmation] = useState(false);

  const store = useSelector((state) => state.store.store);

  const tabs = [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
    { label: "All", value: "all" },
  ];

  const columns = [
    { field: "Table", headerName: "Table" },
    { field: "SequenceNo", headerName: "Sequence" },
  ];

  const loadTables = async () => {
    try {
      setLoading(true);

      const response = await getTables(store?.key);
      let tablesData = response?.tables || [];

      let filteredTables = [];

      if (activeTab === "all") {
        filteredTables = tablesData;
      } else if (activeTab === "active") {
        filteredTables = tablesData.filter((e) => !e.IsDeleted);
      } else if (activeTab === "inactive") {
        filteredTables = tablesData.filter((e) => e.IsDeleted);
      }

      setTables(filteredTables);
    } catch (error) {
      toast.error("Failed to load tables");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (table) => {
    setSelectedTable(table);
    setShowConfirmation(true);
  };

  const handleConfirmDelete = async () => {
    try {
        setShowConfirmation(false);
        setLoading(true);
      const response = await handleDeleteTable(selectedTable?.key);

      if (response?.code === "0") {
        toast.success("Table deleted successfully");
      
        loadTables();
      } else {
        toast.error(response?.message || "Delete failed");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
    finally{
        setLoading(false);
    }
  };

  const handleCancelDelete = () => {
    setShowConfirmation(false);
    setSelectedTable({});
  };

  const onRefresh = () => {
    loadTables();
  };

  useEffect(() => {
    if (store?.key) {
      loadTables();
    }
  }, [activeTab, store]);

  return (
    <>
      <DataViewPage
        iconType={"sales"}
        title={"Tables"}
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={(tab) => setActiveTab(tab)}
        handleOnRefresh={onRefresh}
        header={{
          createButton: {
            createButton: true,
            createButtonText: "New Table",
            onCreateClick: () => {
              setSelectedTable({});
              setAddTable(true);
            },
          },
        }}
      >
        <CustomTable
          columns={columns}
          loading={loading}
          rows={tables}
          handleDelete={(table) => handleDeleteClick(table)}
          handleEdit={(table) => {
            setSelectedTable(table);
            setAddTable(true);
          }}
          loadingRows={25}
          showTextOnRows={tables.length > 0 ? null : "No tables found"}
        />
      </DataViewPage>

      {showAddTable && (
        <AddTable
          closeDrawer={() => setAddTable(false)}
          editData={selectedTable}
          onSuccess={loadTables}
        />
      )}

      {showConfirmation && (
        <ConfirmBox
          title={
            <>
              Are you sure you want to delete{" "}
              <span className="text-red-700">{selectedTable?.Table}</span>?
            </>
          }
          text="This action cannot be undone."
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
        />
      )}
    </>
  );
};

export default Table;